import { axiosBackendInstance } from '../axiosInstance'

export const getSegmentConfig = async (utmSegment) => {
  return axiosBackendInstance.get(`/api/v1/segments/${utmSegment}`)
}
